import type { WPrezentationCardsTranslations } from "./pl";

export const en: WPrezentationCardsTranslations = {
  empty: "No slides to display.",
  cta: "See more",
  openSlideAria: "Open",
  youtubeTitleFallback: "YouTube video",
};
